import { useAuth } from "@/context/AuthContext";
import { LayoutDashboard } from "lucide-react";

export default function Dashboard() {
  const { user } = useAuth();

  return (
    <div className="p-8" data-testid="dashboard-page">
      <div className="mb-8 fade-up">
        <span className="text-sm uppercase tracking-[0.2em] text-muted-foreground">Beranda</span>
        <h1 className="mt-2 font-heading text-4xl font-bold tracking-tight">Dashboard</h1>
        <p className="mt-2 text-sm text-muted-foreground">
          Selamat datang, {user?.username}. Ini adalah ruang kerja Anda.
        </p>
      </div>

      {/* Empty zero-state grid */}
      <div className="grid grid-cols-1 gap-4 md:grid-cols-3 lg:grid-cols-4">
        {Array.from({ length: 4 }).map((_, i) => (
          <div
            key={i}
            className="fade-up flex h-32 items-center justify-center rounded-sm border border-dashed border-border bg-surface/50"
            style={{ animationDelay: `${i * 60}ms` }}
            data-testid={`dashboard-empty-card-${i}`}
          >
            <span className="text-xs uppercase tracking-[0.15em] text-muted-foreground">Kosong</span>
          </div>
        ))}
      </div>

      <div className="mt-8 flex flex-col items-center justify-center rounded-sm border border-border bg-surface/50 py-20 text-center fade-up">
        <div className="grid h-12 w-12 place-items-center rounded-sm border border-border bg-background">
          <LayoutDashboard className="h-5 w-5 text-muted-foreground" />
        </div>
        <h3 className="mt-4 font-heading text-xl font-medium">Belum ada data</h3>
        <p className="mt-1 max-w-xs text-sm text-muted-foreground">
          Dashboard masih kosong. Konten akan muncul di sini seiring berkembangnya aplikasi.
        </p>
      </div>
    </div>
  );
}
